import PageDetail from "../abstract/PageDetail.js";
import { SecurityAcl, SecurityAclContext, AuthCheckAcl } from "../../Security.js";
import { ModalConfirm, ModalAlert } from "../../su/Modals.js";

export default class PageUserDetail extends PageDetail {
	constructor() {
		super();
	}

	init($data) {
		super.init($data);

	
		$(".js-btn-remove").remove();
		if (this.aclContext.HasGrantedAcl(new AuthCheckAcl(this.data.rowSUid, SecurityAcl.ACL_READ))) {
			let args = StateManager._splitUrl(document.location.href);
			let url = Base64.toBase64(this.data.row.Uid, true) + "?_vs=" + encodeURIComponent(args.qPart["_vs"]) + "&_pi=" + this.data.page.PageId;
			$(".jsBtnHistory").attr("href", "/users/history/" + url);
		} else {
			$(".jsBtnHistory").remove();
		}

		if (this.aclContext.HasGrantedAcl(new AuthCheckAcl(this.data.rowSUid, SecurityAcl.ACL_DELETE))) {
			$(".jsBtnRemove").on("click", this.onDelete.bind(this))
		} else {
			$(".jsBtnRemove").remove();
		}
		$(".txt-right").hide();
		if (this.aclContext.HasGrantedAcl(new AuthCheckAcl(this.data.rowSUid, SecurityAcl.ACL_CREATE))
			|| this.aclContext.HasGrantedAcl(new AuthCheckAcl(this.data.rowSUid, SecurityAcl.ACL_DELETE))
			|| this.aclContext.HasGrantedAcl(new AuthCheckAcl(this.data.rowSUid, SecurityAcl.ACL_UPDATE))
			|| this.aclContext.HasGrantedAcl(new AuthCheckAcl(this.data.rowSUid, SecurityAcl.ACL_EXPORT))) {
			$(".txt-right").show();
		}
	}

	onAdd() {
		let args = StateManager._splitUrl(document.location.href);
		document.location.href = TheApp.Env.BaseUrlNls + "users/detail?_pi=" + encodeURIComponent(args.qPart["_pi"]);
	}

	handleErrors(rs) {
		// Overridata per gestire in modo custom gli errori non legati ai singoli campi ma più generali (il messaggio compare in una modal)

		if (rs.StatusCode === 401) {
			return "You do not have permission for this action to complete!"
		}
		if (rs.StatusCode === 412) {
			return "You cannot put this in draft because this item is linked elsewhere!"
		}

		return PageUserDetail.GENERIC_SAVE_ERROR; //500
	}

	getFieldErrorReturnedByServer(rs, code) {
		// Overridata per gestire in modo custom gli errori legati ai campi che arrivano dal server (il messaggio compare vicino al campo in questione)
		if (code === PageUserDetail.ERROR_FIELD_CODE_NOT_UNIQUE) {
			return "This code has already been used (must be unique for every entry)";
		} else {
			let error = null;
			error = TheApp.Res[TheApp.Locale]["ERROR." + code];
			if (!error)
				error = TheApp.Res[TheApp.Locale][code];
			if (error)
				return error
        }
		return code;
	}


	onDelete(dataIndex) {
		let modal = new ModalConfirm($("#template-modalConfirm"));
		modal.create(
			{
				title: "DELETE CONFIRM",
				body: "Are you sure you want to permanently remove this item? You can't undo this action.",
				yes: "YES",
				no: "NO",
				danger: true // viene il pulsante rosso, altrimenti blue
			}, this.onConfirmDelete.bind(this));
		modal.init();
	}

	onConfirmDelete(bConfirm) {
		if (bConfirm) {
			this.showPreloader(true);
			let rq = {
				Value: this.data.row.Uid
			}
			thatServiceManeger.standardCall(this.data.serviceDeleteRoute, rq, this.onDeleteServiceHandler.bind(this));
		}
	}

	onDeleteServiceHandler(rs) {
		this.showPreloader(false);
		//
		if (rs.Success) {
			let args = StateManager._splitUrl(document.location.href);
			let url = "?_vs=" + encodeURIComponent(args.qPart["_vs"]) + "&__pi=" + this.data.page.PrevPageId
			document.location.href = TheApp.Env.BaseUrlNls + "users/" + url;

		} else {
			let error = null;
			if (rs.hasOwnProperty('Errors') && rs.Errors !== null && rs.Errors.length >= 0) {
				error = TheApp.Res[TheApp.Locale]["ERROR." + rs.Errors[0].Code];
				if (rs.Errors[0].RefsUid.length > 0) {
					error = error.replace("{0}", rs.Errors[0].RefsUid);
				}
			}
			if (!error)
				error = TheApp.Res[TheApp.Locale]["ERROR.HTTP." + rs.StatusCode];
			if (!error)
				error = TheApp.Res[TheApp.Locale]["ERROR.HTTP.DEFAULT"];
			//
			let modal = new ModalAlert($("#template-modalAlert"));
			modal.create(
				{
					title: "AN ERROR OCCURRED",
					body: error,
					close: "CLOSE",
					error: true
				});
			modal.init();
		}
	}

}

PageUserDetail.ERROR_FIELD_CODE_NOT_UNIQUE = "UniqueFieldConstraintFailed";

